function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M6.781 8.498H5.22a.468.468 0 0 1-.47-.468V4.748H3.038a.39.39 0 0 1-.275-.666l2.97-2.972a.378.378 0 0 1 .533 0l2.973 2.972a.39.39 0 0 1-.275.666H7.25V8.03c0 .26-.21.468-.469.468zM11 8.342v2.188c0 .26-.21.468-.469.468H1.469A.468.468 0 0 1 1 10.53V8.342c0-.26.209-.469.469-.469h2.656v.157c0 .603.49 1.093 1.094 1.093H6.78c.604 0 1.094-.49 1.094-1.093v-.157h2.656c.26 0 .469.21.469.47zm-2.422 1.719a.392.392 0 0 0-.39-.39.392.392 0 0 0-.391.39c0 .215.175.39.39.39.215 0 .39-.175.39-.39zm1.25 0a.392.392 0 0 0-.39-.39.392.392 0 0 0-.391.39c0 .215.175.39.39.39.215 0 .39-.175.39-.39z"
});

function SvgIconUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon-upload.a4e65da0.svg";
export { ForwardRef as ReactComponent };